import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/cta.css';

const CTA = () => {
  const { user } = useAuth();  // Get auth state

  return (
    <section className="cta">
      <div className="cta-background">
        <div className="cta-shape cta-shape-1"></div>
        <div className="cta-shape cta-shape-2"></div>
        <div className="cta-shape cta-shape-3"></div>
      </div>

      <div className="container cta-content">
        <div className="cta-header reveal-down">
          <h2 className="reveal-text">Ready to Transform Your Teaching?</h2>
          <p>Join thousands of educators who are saving hours every week with Teach Genie™</p>
        </div>

        <div className="cta-features reveal-left" style={{ transitionDelay: '0.2s' }}>
          <div className="cta-feature">
            <span className="feature-icon">✨</span>
            <span className="feature-text">No credit card required</span>
          </div>
          <div className="cta-feature">
            <span className="feature-icon">⚡</span>
            <span className="feature-text">Get 4 free Generations</span>
          </div>
          <div className="cta-feature">
            <span className="feature-icon">🚀</span>
            <span className="feature-text">Start generating in minutes</span>
          </div>
        </div>

        <div className="cta-buttons reveal-right" style={{ transitionDelay: '0.4s' }}>
          <Link to={user ? '/generator' : '/signup'} className="btn btn-accent cta-btn">
            <Sparkles size={20} />
            {user ? 'Go to Dashboard' : 'Start Your Free Trial Now'}
            <ArrowRight size={20} />
          </Link>
          {/* "Meet Our Team" button removed 2026-08-20 — /team unrouted per sir's instruction */}
        </div>
      </div>
    </section>
  );
};

export default CTA;
